import { render, staticRenderFns } from "./SchemaNew.vue?vue&type=template&id=f7de2c5e&scoped=true&"
import script from "./SchemaNew.vue?vue&type=script&lang=js&"
export * from "./SchemaNew.vue?vue&type=script&lang=js&"
import style0 from "./SchemaNew.vue?vue&type=style&index=0&id=f7de2c5e&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7de2c5e",
  null
  
)

export default component.exports